// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9d-0";
export var optionCard = "_9d-1";